module.exports = __webpack_public_path__ + "static/media/social-network.28ac0e63.svg";